import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  Field,
  reduxForm,
  formValueSelector,
  isDirty,
  FieldArray,
  stopSubmit,
} from './finalForm';
import Prompt from '../routes/Prompt';
import LinkContainer from '../components/LinkContainer';
import { connect } from 'react-redux';
import { compose } from 'redux';

import renderField from './render/renderField';
import checkbox from './render/renderCheckbox';
import htmlTextAreaField from './render/renderHtmlTextArea';
import asyncSelectField from './render/renderAsyncSelect';
import { getAddresses, getCities, resetError } from '../actions/app';
import renderSelectField from './render/renderSelectField';
import validateVacancyForm from './validate/validateVacancyForm';
import StatusMessage from '../containers/StatusMessage';
import renderQuestions from './render/renderQuestions';
import { TOOLTIP_TEXTS } from '../utils';
import {
  currencyOptions,
  defaultCountryOptions,
  experienceOptions,
  scheduleOptions,
  specializationOptions,
} from './constants/vacancyFormConstants';
import DownloadImage from '../components/DownloadImage';
import getAddressOptionsFromTeam from '../utils/vacancyUtils';


class EditVacancyForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isAdvancedSettingsOpen: false,
    };
    this.fileRef = React.createRef();
  }

  componentWillUnmount() {
    const { resetError } = this.props;
    resetError('editVacancyError');
  }

  toggleAdvancedSettings = () => {
    this.setState(state => ({ isAdvancedSettingsOpen: !state.isAdvancedSettingsOpen }));
  };

  render() {
    const {
      isAdvancedSettingsOpen,
    } = this.state;

    const { activeTeamShortId } = this.props;
    const {
      handleSubmit,
      submitting,
      team,
      fieldSets,
      countries,
      country,
      city,
      initialValues,
      dirty,
      submitSucceeded,
      change,
      questions,
      questionsData,
      submitFailed,
      isAddAddress,
      toggleAddAddress,
      currentImage,
      onImageChange,
    } = this.props;

    let searchDelayTimer;

    const addressOptions = getAddressOptionsFromTeam(team);

    const hiringTemplateOptions = team
      && team.hiring_templates.map(template => ({
        label: template.name, value: template.id,
      }));

    const jwFieldSetOptions = fieldSets.map(fieldSet => ({
      label: fieldSet.name, value: fieldSet.id,
    }));

    const defaultOptions = {
      currency: currencyOptions.find(option => option.value === initialValues.currency),
      schedule: scheduleOptions.find(option => option.value === initialValues.schedule),
      experience: experienceOptions.find(option => option.value === initialValues.experience),
      hiring_template: hiringTemplateOptions.find(option => option.value === initialValues.hiring_template),
      jwfield_set: jwFieldSetOptions.find(option => option.value === initialValues.jwfield_set),
      addressSelect: addressOptions.find(option => option.label === initialValues.addressSelect.label),
      specialization: specializationOptions.find(option => option.value === initialValues.specialization),
    };

    const loadCountryOptions = inputValue => countries
      .filter(countryOption => countryOption.name.toLowerCase().includes(inputValue.toLowerCase()))
      .filter((value, index) => index < 10)
      .map(countryOption => ({ label: countryOption.name, value: countryOption.name }));

    const getCountryOptions = (inputValue, callback) => {
      callback(loadCountryOptions(inputValue));
    };

    const getCityOptions = inputValue => new Promise((resolve) => {
      clearTimeout(searchDelayTimer);
      searchDelayTimer = setTimeout(() => {
        resolve(getCities(country, inputValue)
          .then(({ data }) => data
            .map((city) => {
              const area = city.area ? `, ${city.area}` : '';
              const region = city.region ? `, ${city.region}` : '';
              return {
                label: city.name + area + region,
                value: city.name,
              };
            })));
      }, 500);
    });

    const getAddressOptions = (inputValue) => {
      const { language } = this.props;
      if (country !== 'Россия') {
        return new Promise(resolve => resolve([{ label: inputValue, value: inputValue }]));
      }
      return new Promise((resolve) => {
        clearTimeout(searchDelayTimer);
        searchDelayTimer = setTimeout(() => {
          resolve(getAddresses(country, city, language, inputValue)
            .then(({ data }) => data
              .map(address => ({
                label: address,
                value: address,
              }))));
        }, 500);
      });
    };

    return (
      <form onSubmit={handleSubmit} className="vacancy-form">
        <Prompt
          when={dirty && !submitSucceeded}
          message="Изменения вакансии не сохранены. Вы уверены, что хотите покинуть страницу?"
        />
        <DownloadImage
          onImageChange={onImageChange}
          currentImage={currentImage}
        />
        <div className="vacancy-form__field">
          <Field
            name="title"
            type="text"
            component={renderField}
            label="Название вакансии"
          />
        </div>
        <div className="vacancy-form__field">
          <Field
            name="specialization"
            type="text"
            component={renderSelectField}
            options={specializationOptions}
            label="Отрасль"
            defaultValue={defaultOptions.specialization}
          />
        </div>
        <div className="vacancy-form__field">
          <Field
            name="salary_from"
            type="number"
            component={renderField}
            label="Зарплата от"
          />
        </div>
        <div className="vacancy-form__field">
          <Field
            name="salary_to"
            type="number"
            component={renderField}
            label="Зарплата до"
          />
        </div>
        <div className="vacancy-form__field">
          <Field
            name="currency"
            component={renderSelectField}
            label="Валюта"
            options={currencyOptions}
            defaultValue={defaultOptions.currency}
          />
        </div>
        <div className="vacancy-form__field">
          <Field
            name="schedule"
            component={renderSelectField}
            label="График работы"
            options={scheduleOptions}
            defaultValue={defaultOptions.schedule}
          />
        </div>
        <div className="vacancy-form__field">
          <Field
            name="experience"
            component={renderSelectField}
            label="Опыт работы"
            options={experienceOptions}
            defaultValue={defaultOptions.experience}
          />
        </div>
        {addressOptions.length > 0 && (
        <React.Fragment>
          {!isAddAddress && (
          <div className="vacancy-form__field">
            <Field
              name="addressSelect"
              componentName="addressSelect"
              component={renderSelectField}
              label="Адрес"
              options={addressOptions}
              defaultValue={defaultOptions.addressSelect}
              placeholder="Адрес не указан"
            />
          </div>
          )}
          <button
            type="button"
            className="button-add-item vacancy-form__button-add-item"
            onClick={toggleAddAddress}
          >
            <span>{isAddAddress ? '-' : '+'}</span>
            Новый адрес
          </button>
        </React.Fragment>
        )}
        {(isAddAddress || addressOptions.length === 0) && (
          <React.Fragment>
            <div className="vacancy-form__field">
              <Field
                name="country"
                componentName="country"
                component={asyncSelectField}
                label="Страна"
                placeholder="Начните вводить название страны..."
                noOptionsMessage="Страна не найдена"
                defaultOptions={defaultCountryOptions}
                loadOptions={getCountryOptions}
              />
            </div>
            <div className="vacancy-form__field">
              <Field
                name="city"
                componentName="city"
                component={asyncSelectField}
                label="Город"
                placeholder={country ? 'Начните вводить...' : 'Сначала выберите страну...'}
                noOptionsMessage="Город не найден"
                loadOptions={getCityOptions}
                isDisabled={!country}
              />
            </div>
            <div className="vacancy-form__field">
              <Field
                name="address"
                componentName="address"
                component={asyncSelectField}
                label="Адрес"
                placeholder={city ? 'Начните вводить...' : 'Сначала выберите город...'}
                noOptionsMessage="Адрес не найден"
                loadOptions={getAddressOptions}
                isDisabled={!city}
              />
            </div>
          </React.Fragment>
        )}
        <div className="vacancy-form__field">
          <Field
            name="is_remote"
            componentName="is_remote"
            component={checkbox}
            label="Удалённая работа"
            classNames="m-0"
            type="checkbox"
          />
        </div>
        <div className="vacancy-form__field">
          <Field
            name="description"
            componentName="description"
            component={htmlTextAreaField}
            label="Задачи"
          />
        </div>
        <div className="vacancy-form__field">
          <Field
            name="requirements"
            componentName="requirements"
            component={htmlTextAreaField}
            label="Требования"
          />
        </div>
        <div className="vacancy-form__field">
          <Field
            name="conditions"
            componentName="conditions"
            component={htmlTextAreaField}
            label="Условия"
          />
        </div>
        <button
          type="button"
          className="button-add-item vacancy-form__button-add-item"
          onClick={this.toggleAdvancedSettings}
        >
          <span>{isAdvancedSettingsOpen ? '-' : '+'}</span>
          Расширенные настройки
        </button>
        {isAdvancedSettingsOpen && (
          <React.Fragment>
            <div className="vacancy-form__field">
              <Field
                name="hiring_template"
                component={renderSelectField}
                label="Шаблон найма"
                tooltipText={TOOLTIP_TEXTS.hiringTemplate}
                options={hiringTemplateOptions}
                defaultValue={defaultOptions.hiring_template}
              />
            </div>
            <div className="vacancy-form__field">
              <Field
                name="jwfield_set"
                component={renderSelectField}
                label="Набор полей"
                tooltipText={TOOLTIP_TEXTS.jwfieldSet}
                options={jwFieldSetOptions}
                defaultValue={defaultOptions.jwfield_set}
              />
            </div>
            <div className="vacancy-form__field">
              <Field
                name="sort_order"
                type="number"
                component={renderField}
                label="Порядок сортировки"
                tooltipText={TOOLTIP_TEXTS.sortOrder}
              />
            </div>
          </React.Fragment>
        )}
        <FieldArray
          name="questions"
          component={renderQuestions}
          change={change}
          questions={questions}
          questionsData={questionsData}
        />
        <div className="buttons-container">
          <button
            className="button"
            type="submit"
            disabled={submitting}
          >
            Сохранить изменения
          </button>
          <LinkContainer
            to={`/teams/${activeTeamShortId}/vacancies`}
          >
            <button type="button" className="button button_color_dark-blue">Отмена</button>
          </LinkContainer>
        </div>
        {submitFailed && <div className="form-error">Не все поля заполнены корректно</div>}
        <StatusMessage status="editVacancyStatus" errorMessage="Ошибка при редактировании вакансии" />
      </form>
    );
  }
}

EditVacancyForm.defaultProps = {
  currentImage: null,
};

EditVacancyForm.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  language: PropTypes.string.isRequired,
  submitting: PropTypes.bool.isRequired,
  team: PropTypes.object.isRequired,
  countries: PropTypes.arrayOf(PropTypes.object).isRequired,
  country: PropTypes.string.isRequired,
  city: PropTypes.string.isRequired,
  initialValues: PropTypes.object.isRequired,
  fieldSets: PropTypes.arrayOf(PropTypes.object).isRequired,
  dirty: PropTypes.bool.isRequired,
  submitSucceeded: PropTypes.bool.isRequired,
  change: PropTypes.func.isRequired,
  questions: PropTypes.arrayOf(PropTypes.object).isRequired,
  questionsData: PropTypes.arrayOf(PropTypes.object).isRequired,
  submitFailed: PropTypes.bool.isRequired,
  resetError: PropTypes.func.isRequired,
  activeTeamShortId: PropTypes.string.isRequired,
  isAddAddress: PropTypes.bool.isRequired,
  toggleAddAddress: PropTypes.func.isRequired,
  onImageChange: PropTypes.func.isRequired,
  currentImage: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.object,
  ]),
};

const mapStateToProps = (state) => {
  const {
    app: { activeTeamShortId, activeTeam },
    entities: { teams },
  } = state;
  const activeTeamInfo = teams[activeTeam];
  const { style: { language } } = activeTeamInfo;
  const selector = formValueSelector('editVacancy');
  const dirty = isDirty('editVacancy')(state);
  const country = selector(state, 'country');
  const countryValue = country ? country.value : '';
  const city = selector(state, 'city');
  const cityValue = city ? city.value : '';
  const questionsData = selector(state, 'questions') || [];
  return {
    language,
    country: countryValue,
    city: cityValue,
    dirty,
    questionsData,
    activeTeamShortId,
  };
};

const mapDispatchToProps = dispatch => ({
  resetError: name => dispatch(resetError(name)),
});

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  reduxForm({
    form: 'editVacancy',
    validate: validateVacancyForm,
    onChange: (values, dispatch, props) => {
      if (props.submitFailed) {
        dispatch(stopSubmit('editVacancy'));
      }
    },
  }),
)(EditVacancyForm);
